/** @jsxImportSource @emotion/react */

import { useTheme } from '@emotion/react';
import { data } from '../Data';

import { ReactComponent as Logo } from '../Header/habanero-logo.svg';

const FooterLink = ({
  href,
  children,
  ...props
}: React.ClassAttributes<HTMLAnchorElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const theme = useTheme();

  return (
    <a
      css={{
        color: theme.color.slateDark,
        textDecoration: 'underline',

        '&:focus, &:hover': {
          color: theme.color.primary
        }
      }}
      href={href}
      key={href}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    >
      {children}
    </a>
  );
};

export const Footer = () => {
  const theme = useTheme();

  return (
    <footer
      css={{
        color: theme.color.slate,
        textAlign: 'center'
      }}
    >
      <div
        css={{
          margin: '0 auto',
          maxWidth: '670px',
          padding: '2rem 1.5rem 10rem 1.5rem'
        }}
      >
        <picture>
          <Logo css={{ height: 37, width: 206 }} />
        </picture>
        <div
          css={{
            fontSize: theme.fontSizes[4]
          }}
        >
          <p>
            We’re people, culture and technology experts with a passion for purpose. We help organizations thrive by designing employee
            experiences that empower everyone to bring their best selves to work.
          </p>
          <p>
            Connect with us on{' '}
            <FooterLink key={'linkedin'} href="https://www.linkedin.com/company/habanero-consulting-group">
              LinkedIn
            </FooterLink>
            ,{' '}
            <FooterLink key={'twitter'} href="https://twitter.com/HabaneroConsult">
              Twitter
            </FooterLink>
            , or{' '}
            <FooterLink key={'instagram'} href="https://www.instagram.com/habaneroconsulting">
              Instagram
            </FooterLink>
            .
          </p>
        </div>
        <div
          css={{
            marginTop: '64px'
          }}
        >
          <p>
            <small css={{ fontSize: theme.fontSizes[2] }}>
              Your 2021 tarot-scope is meant to amuse and inspire only and should not be used to navigate career transitions, personal life
              choices or pet adoption. None of us knows what 2021 will bring. May we all have the opportunity to do the things that make us
              feel whole, human and connected.
            </small>
          </p>

          <p
            css={{
              margin: '0 auto',
              maxWidth: '440px'
            }}
          >
            <small css={{ fontSize: theme.fontSizes[2] }}>
              Copyright &copy;2020 Habanero Consulting Group. All rights reserved. Please read our{' '}
              <FooterLink key={'terms_of_use'} href={data.dictionary.terms_of_use_url}>
                terms of use
              </FooterLink>{' '}
              and{' '}
              <FooterLink key={'privacy_policy_url'} href={data.dictionary.privacy_policy_url}>
                privacy policy
              </FooterLink>
              .
            </small>
          </p>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';
